import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { MediaDelete } from "../../apis/api/GalleryApis";
import Cookies from "js-cookie";
const VideosGallery = () => {
  const [Photodata, setPhotodata] = useState([]);
  const [Videodata, setVideodata] = useState([]);
    const company_id = Cookies.get("company_id");
    const UserID = Cookies.get("userID");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [videoToDelete, setVideoToDelete] = useState(null);

  const { media } = useSelector((state) => state.GallerySlice);

  useEffect(() => {
    if (media?.result && media?.result?.length > 0) {
      const photoItems = media?.result?.filter(
        (item) => item.extension_type === "image"
      );
      const videoItems = media.result.filter(
        (item) => item.extension_type === "video"
      );

      setPhotodata(photoItems);
      setVideodata(videoItems);
    }
  }, [media]);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
    setShowModal(true);
    document.body.classList.add("modal-open");
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedVideo(null);
    document.body.classList.remove("modal-open");
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal")) {
      handleClose();
    }
  };

  const handleDelete = async (id) => {
    try {
     
      const updatedVideos = Videodata.filter((video) => video.id !== id);
      const res =await dispatch(MediaDelete({id:id}))
      setVideodata(updatedVideos);
    } catch (error) {
      console.error("Delete error:", error);
     
    }
  };
 
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") handleClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div  className="bg-white" style={{ height: "85vh"}}>
      {/* <h2 className="text-center mb-4">Videos Gallery</h2> */}
      {/* <div className="d-flex justify-content-end mb-3">
        <button
          className="btn btn-sm btn-secondary"
          onClick={() => navigate(-1)}
        >
          <i className="bx bx-left-arrow-alt"></i> Back
        </button>
      </div> */}

      <div className="row">
  {Videodata?.map((item, index) => (
    <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 p-4">
      <div
        className="shadow-sm p-3 rounded h-100 d-flex flex-column border"
        style={{
          cursor: "pointer",
          backgroundColor: "#f8f9fa",
          position: "relative",
          transition: "transform 0.3s ease",
        }}
        onClick={() =>
          handleVideoClick({
            src: item.file_url,
            title: item.title || item.tittle || "Untitled Video",
          })
        }
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {UserID === item?.member_id && company_id === item?.company_id && (
          <button
            className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
            onClick={(e) => {
              e.stopPropagation(); // prevent modal open
              setVideoToDelete(item.id);
              setDeleteConfirmModal(true);
            }}
          >
            <i className="bx bx-trash"></i>
          </button>
        )}

        {/* Video preview */}
        <div className="position-relative">
          <video
            src={item.file_url}
            className="img-fluid rounded w-100"
            style={{ maxHeight: "200px", objectFit: "cover" }}
            controls
          ></video>
        </div>

        {/* Title */}
        <div className="mt-2 text-center">
          <h6
            className="mb-0 text-truncate"
            title={item.title || item.tittle}
            style={{ fontSize: "14px" }}
          >
            {item.title || item.tittle}
          </h6>
        </div>
      </div>
    </div>
  ))}
</div>



      {selectedVideo && showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={handleBackdropClick}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedVideo.title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>
              <div className="modal-body text-center">
                <video
                  src={selectedVideo.src}
                  controls
                  autoPlay
                  className="img-fluid rounded w-100"
                ></video>
              </div>
            </div>
          </div>
        </div>
      )}

 
      {deleteConfirmModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDeleteConfirmModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this video?</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setDeleteConfirmModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    handleDelete(videoToDelete);
                    setDeleteConfirmModal(false);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideosGallery;
